<template>
  <div id="app">
    <router-view name="top" v-if="$store.state.top" />
    <!-- <router-view name="banner" v-if="$store.state.banner"/> -->
    <div class="container">
      <router-view name="user" v-if="$store.state.user" />
    </div>
    <div class="x-content">
      <!-- <keep-alive>  -->
      <router-view />
      <!-- </keep-alive> -->
    </div>
    <router-view name="footer" v-if="$store.state.footer" />
    <router-view name="floatAd" v-if="$store.state.floatAd" />
    <router-view name="fixedImg" v-if="$store.state.fixedImg" />
  </div>
</template>

<script>
// 导入组件
export default {
  name: 'app',
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true //再打开
      })
    },
  },
}
</script>

<style></style>
